<mat-form-field appearance="outline" subscriptSizing="dynamic" class="icon-picker-field" cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <mat-label>{{ label | translate }}</mat-label>
  <mat-icon matPrefix class="icon-picker-current">{{ value || 'hide_image' }}</mat-icon>
  <input matInput readonly class="icon-picker-input" [value]="value || ('icon_picker.none' | translate)" (click)="toggle()" />
  <mat-icon matSuffix class="icon-picker-arrow" (click)="toggle()">arrow_drop_down</mat-icon>
</mat-form-field>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="positions" [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" (backdropClick)="open.set(false)" (detach)="open.set(false)">
  <div class="icon-picker-panel">
    <input class="icon-picker-search" type="text" [placeholder]="'icon_picker.search' | translate" [value]="search()"
      (input)="search.set($any($event.target).value)" />

    <div class="icon-picker-grid">
      <button type="button" class="icon-option none-option" [class.selected]="!value" [title]="'icon_picker.none' | translate" (click)="choose(null)">
        <mat-icon>block</mat-icon>
      </button>

      @if (custom(); as name) {
        <button type="button" class="icon-option custom-option" [title]="name" (click)="choose(name)">
          <mat-icon>{{ name }}</mat-icon>
        </button>
      }

      @for (icon of visibleIcons(); track icon) {
        <button type="button" class="icon-option" [class.selected]="icon === value" [title]="icon" (click)="choose(icon)">
          <mat-icon>{{ icon }}</mat-icon>
        </button>
      }
    </div>

    @if (custom()) {
      <span class="icon-picker-hint">{{ 'icon_picker.custom_hint' | translate }}</span>
    }
  </div>
</ng-template>
